"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DISCOUNT_TYPE;
(function (DISCOUNT_TYPE) {
    DISCOUNT_TYPE[DISCOUNT_TYPE["MEMBERSHIP_DISCOUNT"] = 0] = "MEMBERSHIP_DISCOUNT";
    DISCOUNT_TYPE[DISCOUNT_TYPE["CART_PROMO_DISCOUNT"] = 1] = "CART_PROMO_DISCOUNT";
    DISCOUNT_TYPE[DISCOUNT_TYPE["AUTO_APPLIED_DISCOUNT"] = 2] = "AUTO_APPLIED_DISCOUNT";
})(DISCOUNT_TYPE = exports.DISCOUNT_TYPE || (exports.DISCOUNT_TYPE = {}));
var Errors;
(function (Errors) {
    // ERRORS
    Errors["NO_ERROR"] = "NO_ERROR";
    Errors["GENERIC"] = "CE000";
    Errors["INACTIVE"] = "CE001";
    Errors["INVALID"] = "CE002";
    Errors["EXPIRED"] = "CE003";
    Errors["VALID_IN_FUTURE"] = "CE004";
    Errors["ALREADY_USED"] = "CE005";
    Errors["NO_MEMBERSHIP"] = "CE006";
})(Errors = exports.Errors || (exports.Errors = {}));
var Warnings;
(function (Warnings) {
    Warnings["DOES_NOT_APPLY"] = "CW001";
    Warnings["WILL_BE_VALIDATED"] = "WILL_BE_VALIDATED";
    Warnings["SELECTED_SHIPPING_INVALID"] = "SELECTED_SHIPPING_INVALID";
})(Warnings = exports.Warnings || (exports.Warnings = {}));
var CartStates;
(function (CartStates) {
    CartStates["NON_EXISTENT_CART"] = "0";
    CartStates[CartStates["NON_EXISTENT_CART_VERSION"] = 1] = "NON_EXISTENT_CART_VERSION";
})(CartStates = exports.CartStates || (exports.CartStates = {}));
var DISCOUNT_CODE_CUSTOM_FIELD;
(function (DISCOUNT_CODE_CUSTOM_FIELD) {
    DISCOUNT_CODE_CUSTOM_FIELD["TUITION_PROVIDER"] = "tuition_provider";
    DISCOUNT_CODE_CUSTOM_FIELD["FLP_RESELLER"] = "flp_reseller";
    DISCOUNT_CODE_CUSTOM_FIELD["ORGANIZATION"] = "organization";
})(DISCOUNT_CODE_CUSTOM_FIELD = exports.DISCOUNT_CODE_CUSTOM_FIELD || (exports.DISCOUNT_CODE_CUSTOM_FIELD = {}));
//# sourceMappingURL=index.js.map